import React, { useEffect, useState } from "react";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { MdClear } from "react-icons/md";
import { useTranslation } from "react-i18next";
import AppButton from "../../../shared/AppButton";

const DragNdrop = ({
  width,
  height,
  formik,
  formattedData,
  setFormattedData,
}) => {
  const [files, setFiles] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    if (formik.values?.data.length === 0) {
      formik.resetForm();
      setFiles("");
    }
  }, [formik.values?.data]);

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files[0];
    if (selectedFiles) setFiles(selectedFiles);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = event.dataTransfer.files[0];
    if (droppedFiles) setFiles(droppedFiles);
  };

  const handleRemoveFile = (index) => {
    const newData = formik.values?.data.filter((_, i) => i !== index);
    setFormattedData(newData);
    formik.setFieldValue("data", newData);
  };

  useEffect(() => {
    formik.setFieldValue("file", files);
  }, [files]);

  return (
    <div style={{ width, height }}>
      {/* Drop Zone */}
      <div
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        className={`border-2 border-dashed rounded-lg px-3 py-3 flex flex-col items-center justify-center text-center transition-colors cursor-pointer ${
          files
            ? "border-[#0070C2] bg-blue-50"
            : "border-gray-300 bg-slate-50 hover:border-[#0070C2] hover:bg-blue-50/40"
        }`}
      >
        <AiOutlineCloudUpload
          className={`text-3xl mb-2 ${files ? "text-[#0070C2]" : "text-gray-400"}`}
        />
        <p className="text-xs font-semibold text-gray-600">
          {t("Drag and drop your files here")}
        </p>
        <p className="text-[10px] text-gray-400 mt-0.5">
          {t("Limit 10MB per file. Supported file: .zip")}
        </p>

        <input
          type="file"
          accept=".zip"
          hidden
          id="browse-attachment"
          onChange={handleFileChange}
        />
        <label htmlFor="browse-attachment" className="mt-2">
          <AppButton
            label={t("Browse files")}
            onClick={() => document.getElementById("browse-attachment").click()}
            className="!py-0.5 !px-3 !text-[11px]"
          />
        </label>
      </div>

      {/* Selected ZIP file name */}
      {files && (
        <div className="mt-2 flex items-center justify-between bg-blue-50 border border-blue-200 rounded-lg px-3 py-1.5">
          <span className="text-xs text-[#0070C2] font-medium truncate max-w-[80%]">
            🗜️ {files.name}
          </span>
        </div>
      )}

      {/* Extracted Files List */}
      {formik.values?.data && formik.values?.data.length > 0 && (
        <div className="mt-2 flex flex-col gap-1 max-h-40 overflow-y-auto">
          <p className="text-[10px] font-bold text-gray-500 uppercase tracking-wider">
            {t("Extracted Files")} ({formik.values.data.length})
          </p>
          {formik.values.data.map((file, i) => (
            <div
              key={i}
              className="flex items-center justify-between bg-blue-50 border border-blue-100 rounded-md px-3 py-1"
            >
              <span className="text-[11px] text-[#0070C2] font-medium truncate max-w-[85%]">
                📄 {file?.claim_no}{" "}
                <span className="text-gray-400 font-normal">
                  ({file?.attachment?.filename})
                </span>
              </span>
              <MdClear
                className="text-gray-400 hover:text-red-500 cursor-pointer flex-shrink-0 transition-colors"
                onClick={() => handleRemoveFile(i)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DragNdrop;
